/**
 * Hero Load Animation
 * Adds 'loaded' class to trigger hero section animations
 */

export default function initHeroLoadAnimation() {
    // Wait for DOM to be fully loaded
    window.addEventListener('DOMContentLoaded', function () {
        // const homeHero = document.querySelector('.home-hero');
        const bannerFormIcon = document.querySelector('.bannerFormIconWrapper');
        const header = document.querySelector('.header');

        // if (!homeHero) return;

        // Add a small delay to ensure everything is rendered
        setTimeout(function () {
            // Add loaded class to home-hero to trigger img-wrapper and title animations
            // homeHero.classList.remove('loaded');
            if (header) {
                header.classList.add('loaded');
            }
            // Add loaded class to bannerFormIconWrapper if it exists
            if (bannerFormIcon) {
                bannerFormIcon.classList.add('loaded');
            }
            // const imgWrapper = document.querySelector('.img-wrapper');
            // if (imgWrapper) {
            //     imgWrapper.classList.add('loaded');
            // }
        }, 1000); // Small delay to ensure smooth start
    });
}

// Initialize the animation
initHeroLoadAnimation();
